import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService } from '@shared/services';

@Injectable({ providedIn: 'root' })
export class I18nService {
	private translateService: TranslateService = inject(TranslateService);
	private readonly authenticationService: AuthenticationService = inject(AuthenticationService);

	private supported = ['ES', 'EN', 'PT', 'IT', 'FR', 'DE', 'EU', 'NO'];
	private fallback = 'ES';

	private user = this.authenticationService.user;

	private langSignal = signal<string>(this.fallback);

	readonly lang = this.langSignal.asReadonly();

	init() {
		const initial = this.getLang();

		this.translateService.addLangs(this.supported);
		this.translateService.setFallbackLang(this.fallback);

		this.setLang(initial);
	}

	setLang(lang: string) {
		const normalized = lang.toUpperCase();
		this.translateService.use(normalized);
		localStorage.setItem('lang', normalized);
		this.langSignal.set(normalized);
	}

	getLang(): string {
		const saved = localStorage.getItem('lang')?.toUpperCase();
		const currentUserLanguage = this.user().language?.toUpperCase();
		const browser = (this.translateService.getBrowserLang?.() || '').toUpperCase();

		const initial =
			[saved, currentUserLanguage, browser].find(
				(language): language is string => !!language && this.supported.includes(language)
			) ?? this.fallback;

		return initial;
	}
}
